import device from './device'

export default {
  device,
}
